// extracted by css-extract-rspack-plugin
export default {"translucentWhite":"_59e3a072"};